import React from 'react';
import { Link } from 'react-router-dom';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

const Nav = () => {
  return (
        <MDBRow className='pt-2'>
          <div className='mx-auto'>
            <MDBCol size='12' className='d-flex justify-content-center'>     
                <Link to='/' className='text-black fs-5'><pre className='navText'>Home | </pre></Link>
                <Link to='/about' className='text-black fs-5'><pre className='navText'>About | </pre></Link>
                <Link to='/contact' className='text-black fs-5'><pre className='navText'>Contact | </pre></Link>
                <Link to='/gallery' className='text-black fs-5'><pre className='navText'>Gallery | </pre></Link>
                <Link to='/mint' className='text-black fs-5'><pre className='navText'>Mint</pre></Link>
            </MDBCol>
          </div>
        </MDBRow> 
  )
}

export default Nav;